import ServiceSlider from "../ServicesPage/ServiceSlider";
import TendersBanner from "./TendersBanner"; 
import TenderTabs from "./TenderTabs";

function TendersPage() {
    return (
      <>
      <TendersBanner/>
      <TenderTabs/>
      {/* <section className="latest-marine-info px-3" id="latest-marine-info">
        <div className="container max-1280">
          <ServiceSlider />
          
        </div>
      </section> */}
      
      </>
    )
  }
  
  export default TendersPage;